import { graphql } from '@/gql';
import type { UpdateSmsTemplateMutation, UpdateSmsTemplateMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdateSmsTemplateInput = UpdateSmsTemplateMutationVariables;

export type UpdateSmsTemplateOutput = UpdateSmsTemplateMutation['updateSmsTemplate'];

export const updateSmsTemplate = async ({ id, template }: UpdateSmsTemplateInput): Promise<UpdateSmsTemplateOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateSmsTemplate($id: Float!, $template: String!) {
        updateSmsTemplate(id: $id, template: $template) {
          id
          name
          template
          createdAt
          updatedAt
        }
      }
    `),
    variables: {
      id,
      template,
    },
  });

  return response.data!.updateSmsTemplate;
};
